import * as React from 'react';

import CurrencyTable from './CurrenciesTable';
import { RouteComponentProps } from 'react-router';

interface ICurrenciesProps extends RouteComponentProps<{ 
    eshop: string;
    currencyId: string;
}> {
    
}

export default class Currencies extends React.Component<ICurrenciesProps> {

    render() {
        return (
            <div>
                <CurrencyTable
                    domain={this.props.match.params.eshop}
                    currencyId={this.props.match.params.currencyId}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/scenes/Currencies/index.tsx